import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, saveAuthToken, clearAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [parental, setParental] = useState({ kid_safe: false, max_maturity: "mature" });
  const [coins, setCoins] = useState(0);

  const refreshWallet = useCallback(async () => {
    try {
      const { data } = await api.get("/wallet");
      setCoins(data.coins);
    } catch (_) {}
  }, []);

  const loadParental = useCallback(async () => {
    try {
      const { data } = await api.get("/parental");
      setParental(data);
    } catch (_) {}
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from Google OAuth, skip /me — AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        loadParental();
        refreshWallet();
      } catch (_) {
        setUser(false);
      }
    })();
  }, [loadParental, refreshWallet]);

  const login = async (payload, mode = "login") => {
    const { data } = await api.post(`/auth/${mode}`, payload);
    if (data?.token) saveAuthToken(data.token);
    setUser(data);
    loadParental();
    refreshWallet();
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    clearAuthToken();
    setUser(false);
    setCoins(0);
    setParental({ kid_safe: false, max_maturity: "mature" });
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, parental, setParental, loadParental, coins, setCoins, refreshWallet }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
